
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetPriorityAisIec as ObiTargetPriorityAisIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-priority-ais-iec.js';
 
 
 

 
 export const ObiTargetPriorityAisIec = createComponent({
   react: React,
   tagName: 'obi-target-priority-ais-iec',
   elementClass: ObiTargetPriorityAisIecElement,
   events: {
     
   }
  });
 
 